import React, {ChangeEvent, ChangeEventHandler, FC, HTMLAttributes} from 'react';
import styled from "styled-components";

interface TextAreaProps extends HTMLAttributes<HTMLTextAreaElement> {
    value?: string
    placeholder?: string
    onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
}

const StyledTextarea = styled.textarea`
  width: 100%;
  height: 230px;
  background: #F7F1ED;
  border-radius: 15px;
  padding: 25px;
  border: none;
  color: #3B5049 !important;    
`

const Textarea: FC<TextAreaProps> = ({ value, placeholder,onChange, ...props }) => {
    return <StyledTextarea placeholder={placeholder} value={value} onChange={onChange} {...props} />
}

export default Textarea;